import { useTheme } from '@mui/material'

import { IconProps } from '@f-fertighaus/applications/Next/types/icon'

export const RoofTypeIcon = (props: IconProps) => {
  const theme = useTheme()
  const stroke = props.color || theme.palette.primary.main
  return (
    <svg
      width='16'
      height='16'
      viewBox='0 0 16 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'>
      <g clipPath='url(#clip0_414_1673)'>
        <path
          d='M0.594429 11.2788L3.59493 4.77871L13.2706 4.77871'
          stroke={stroke}
          strokeLinecap='round'
        />
        <path
          d='M3.71776 4.77841L13.3935 4.77841L14.499 10.4665L11 10.466'
          stroke={stroke}
          strokeLinecap='round'
        />
        <path
          d='M13.3939 4.82915L10.3934 11.3292L0.717633 11.3292'
          stroke={stroke}
          strokeLinecap='round'
        />
      </g>
      <defs>
        <clipPath id='clip0_414_1673'>
          <rect width='16' height='16' fill='white' />
        </clipPath>
      </defs>
    </svg>
  )
}
